import { render, staticRenderFns } from "./spu-import.vue?vue&type=template&id=3ce9a21f&scoped=true"
import script from "./spu-import.vue?vue&type=script&lang=js"
export * from "./spu-import.vue?vue&type=script&lang=js"
import style0 from "./spu-import.vue?vue&type=style&index=0&id=3ce9a21f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ce9a21f",
  null
  
)

export default component.exports